module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Redo-9471b5a88a169dd4508b40031aa6e0e2.svg";